import { useEffect, useState } from "react";
import { IOption } from "../../../../../types/Option";
import TicklersTypeService from "../../../../../services/administration/ticklers";

export const useFetchTicklerTypes = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [options, setOptions] = useState<IOption[]>([]);

  useEffect(() => {
    TicklersTypeService.fetchNames()
      .then((res: any) => {
        const result: IOption[] = res.map((record: any) => ({
          label: record.name,
          value: record.id,
        }));

        result.unshift({
          label: "All",
          value: "All",
        });

        setOptions(result);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, []);

  return { isLoading, options };
};
